<script>
	import ListNotificaciones from '@/components/notificaciones/ListNotificaciones.vue';
	import {
		mapState,
		mapActions
	} from "vuex"; //mapState
	export default {
		props: {
			show: {
				type: Boolean,
				required: true
			}
		},
		components: {
			ListNotificaciones
		},
		data() {
			return {
			};
		},
		computed: {
			...mapState("NotificacionModule", ["notificaciones", "paginas_notificaciones"]),
		},
		async created() {
			await this.getDataNotificaciones();
		},
		
		methods: {
			...mapActions("NotificacionModule", ["getNotificaciones", "deleteNotificaciones", "verNotificacion"]),
			//GET
			async getDataNotificaciones() {
				//this.loadingVideo = true;
				let data2_ = {
					id_empresa: this.$ls.get("user").id_empresa_fk,
					id_usuario: this.$ls.get("user").id_usuario,
					limite: "15"
				}
				let pagina = "1";
				let id_privilegio = this.$ls.get("user").privilegio[0].id_tipo;
				//console.log("data2_: ", data2_, " pagina: ", pagina, "privilegio: ", id_privilegio);
				await this.getNotificaciones({
					data2_,
					pagina,
					id_privilegio
				});
				//this.loadingVideo = false;
				//this.notificaciones = notificaciones;
			},
			async notificacionVista(item) {
				// solo ingresa a la mutación si la notificación no esta vista por el usuario.
				if (!item.vista) {
					let arrayNotificacion = [];
					arrayNotificacion.push(item.id);
					let data_ = {
						id_empresa: this.$ls.get("user").id_empresa_fk,
						id_usuario: this.$ls.get("user").id_usuario,
						id_notificaciones: arrayNotificacion
					}
					await this.verNotificacion(data_);
				}
			},
			//Elimina una notificación
			async deleteNotification(data) {
				let arrayNotificacion = [];
				arrayNotificacion.push(data.id);
				let data_ = {
					id_empresa: this.$ls.get("user").id_empresa_fk,
					id_usuario: this.$ls.get("user").id_usuario,
					id_notificaciones: arrayNotificacion
				}
				await this.deleteNotificaciones(data_);
			},
			async deleteAll() {
				let notificacionesDelete = [];
				this.notificaciones.forEach(element => {
					notificacionesDelete.push(element.id);
				});
				let data_ = {
					id_empresa: this.$ls.get("user").id_empresa_fk,
					id_usuario: this.$ls.get("user").id_usuario,
					id_notificaciones: notificacionesDelete
				}
				//console.log("data_ delete total: ", data_);
				await this.deleteNotificaciones(data_);
				await this.getDataNotificaciones();
				//this.notificaciones = [];
			}
		},

	}
</script>
<template>
	<section id="slide-notificaciones" class="slide-right d-flex flex-column p-4" :class="{ 'slide-right-show': show }">
		<div class="d-flex justify-content-between align-items-center mb-4">
			<h4 class="d-flex align-items-center font-700 color-main">
				<img width="35" height="35" class="me-2" src="@/assets/img/intranet/layout/notificacion.svg"> Notificaciones
			</h4>
		</div>
		<div class="d-flex justify-content-end">
			<div class="ms-3">
				<button @click="deleteAll()" type="button" class="btn btn-custom btn-custom-main rounded-pill mw-150" :disabled="notificaciones.length === 0">
						Eliminar todo
					</button>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-12">
				<template v-if="notificaciones.length !== 0">
					<ListNotificaciones
						:data="notificaciones"
						@notificacionVista="notificacionVista"
						@deleteNotification="deleteNotification"
					/>
				</template>
				<template v-if="notificaciones.length === 0">
					<div class="alert alert-info text-center">
						<font-awesome-icon icon="fa-solid fa-circle-info"></font-awesome-icon> Sin notificaciones para mostrar.
					</div>
				</template>
			</div>
		</div>		
	</section>
</template>
